import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WeatherType } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class WeatherService {
  private scriptId = 'weathers';

  constructor() {}

  getWeathers(): Observable<WeatherType[]> {
    // Grab the <script> element
    const scriptEl = document.getElementById(this.scriptId) as HTMLScriptElement;

    if (!scriptEl || !scriptEl.textContent) {
      console.error(`Script element #${this.scriptId} not found or empty.`);
      return of([]);
    }

    // Parse JSON and return as Observable
    const data: WeatherType[] = JSON.parse(scriptEl.textContent);
    return of(data);
  }
}
